import React from 'react'
import {css} from '@emotion/react'
import {Accordion, AccordionDetails, AccordionSummary} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import ToolList from './ToolList'



function CategoryPanel({currentToolKey, categoryToolInfo, ...props}) {
  const styles = {
    root: css`
    `,

    header: css`
      font-size: 1.2rem;
      font-weight: 600;
    `,
  }

  const defaultExpanded = React.useMemo(() => {
    return categoryToolInfo.tools.map(tool => tool.key).includes(currentToolKey)
  }, [categoryToolInfo.tools, currentToolKey])

  return (
    <>
      <Accordion css={styles.root} defaultExpanded={defaultExpanded} {...props}>
        <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
          <div css={styles.header}>{categoryToolInfo.label}</div>
        </AccordionSummary>
        <AccordionDetails css={styles.detail}>
          <ToolList tools={categoryToolInfo.tools}/>
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default React.memo(CategoryPanel)